import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {CompetitorPlayersStatsModulePlayerViewModel} from "../../models/competitor-players-stats-module.player.view-model";
import {CompetitorPlayersStatsModulePlayerStatsTopStatsContentCard} from "./competitor-players-stats-module.player-stats.top-stats.content.card";
import {LineupsMemberStatsViewModel} from "../../../../domain/yard/lineups/lineups-member/stats/lineups-member.stats.view-model";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";

export class CompetitorPlayersStatsModulePlayerStatsTopStatsContentProps extends BaseProps {
  player: CompetitorPlayersStatsModulePlayerViewModel;
  topStatsIconSize: Number;
  isSmallView: Boolean;
}

export const CompetitorPlayersStatsModulePlayerStatsTopStatsContent = ({player, topStatsIconSize, isSmallView}: CompetitorPlayersStatsModulePlayerStatsTopStatsContentProps) => {
  return (
    <div className={classNames(styles.player_stats_top_stats_content_container)}>
      {
        player.topStats.map((stat: LineupsMemberStatsViewModel) =>
          <CompetitorPlayersStatsModulePlayerStatsTopStatsContentCard
            stat={stat}
            topStatsIconSize={topStatsIconSize}
            isSmallView={isSmallView}
            key={stat.imageId}/>
        )
      }
    </div>
  )
}
